import styled from '@emotion/styled';
import DropDown from '../../../components/DropDown';

export const Wrapper = styled(DropDown)`
  margin: auto;
  padding: 1rem;
  width: 100%;
`;
